(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["droneer-expandable-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('droneer-expandable-showcase')) {
    customElements.define(
      'droneer-expandable-showcase',
      class DroneerExpandableShowcase extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.panels = Array.from(this.querySelectorAll('[data-expandable-panel]'));
          this.desktopQuery = window.matchMedia('(min-width: 1024px)');
          this.abortController = new AbortController();
          this.handleClick = this.handleClick.bind(this);
          this.handleMouseLeave = this.handleMouseLeave.bind(this);
          this.handleFocusIn = this.handleFocusIn.bind(this);
          this.handleFocusOut = this.handleFocusOut.bind(this);
          this.handleModeChange = this.handleModeChange.bind(this);
          this.handleBlockSelect = this.handleBlockSelect.bind(this);

          this.panels.forEach((panel) => {
            panel.addEventListener(
              'mouseenter',
              () => {
                if (!this.desktopQuery.matches) return;
                this.openPanel(Number.parseInt(panel.dataset.panelIndex, 10), true);
              },
              { signal: this.abortController.signal }
            );
          });

          this.addEventListener('click', this.handleClick, { signal: this.abortController.signal });
          this.addEventListener('mouseleave', this.handleMouseLeave, { signal: this.abortController.signal });
          this.addEventListener('focusin', this.handleFocusIn, { signal: this.abortController.signal });
          this.addEventListener('focusout', this.handleFocusOut, { signal: this.abortController.signal });
          this.addEventListener('shopify:block:select', this.handleBlockSelect, { signal: this.abortController.signal });

          if (this.desktopQuery.addEventListener) {
            this.desktopQuery.addEventListener('change', this.handleModeChange);
          } else {
            this.desktopQuery.addListener(this.handleModeChange);
          }

          this.syncMode();
        }

        disconnectedCallback() {
          if (!this.initialized) return;

          this.abortController.abort();

          if (this.desktopQuery.addEventListener) {
            this.desktopQuery.removeEventListener('change', this.handleModeChange);
          } else {
            this.desktopQuery.removeListener(this.handleModeChange);
          }

          this.initialized = false;
        }

        handleClick(event) {
          const button = event.target.closest('[data-expandable-toggle]');
          if (!button || !this.contains(button)) return;

          const panel = button.closest('[data-expandable-panel]');
          if (!panel) return;

          this.openPanel(Number.parseInt(panel.dataset.panelIndex, 10), this.desktopQuery.matches);
        }

        handleMouseLeave() {
          if (this.desktopQuery.matches) this.clearDesktopState();
        }

        handleFocusIn(event) {
          if (!this.desktopQuery.matches) return;

          const panel = event.target.closest('[data-expandable-panel]');
          if (!panel) return;

          this.openPanel(Number.parseInt(panel.dataset.panelIndex, 10), true);
        }

        handleFocusOut(event) {
          if (!this.desktopQuery.matches) return;
          if (event.relatedTarget && this.contains(event.relatedTarget)) return;

          this.clearDesktopState();
        }

        handleModeChange() {
          this.syncMode();
        }

        handleBlockSelect(event) {
          const panel = event.target.closest('[data-expandable-panel]');
          if (!panel || !this.contains(panel)) return;

          this.openPanel(Number.parseInt(panel.dataset.panelIndex, 10), this.desktopQuery.matches);
          panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }

        syncMode() {
          if (this.desktopQuery.matches) {
            this.clearDesktopState();
            return;
          }

          const currentIndex = this.panels.findIndex((panel) => panel.classList.contains('is-active'));
          this.openPanel(currentIndex >= 0 ? currentIndex : 0, false);
        }

        openPanel(index, interactive) {
          if (!Number.isInteger(index) || index < 0 || index >= this.panels.length) return;

          this.panels.forEach((panel, panelIndex) => {
            const isActive = panelIndex === index;
            const button = panel.querySelector('[data-expandable-toggle]');
            const description = panel.querySelector('[data-expandable-description]');

            panel.classList.toggle('is-active', isActive);
            button?.setAttribute('aria-expanded', String(isActive));
            description?.setAttribute('aria-hidden', String(!isActive));
          });

          this.classList.toggle('is-interacting', this.desktopQuery.matches && interactive);
        }

        clearDesktopState() {
          this.classList.remove('is-interacting');
          this.panels.forEach((panel) => {
            panel.querySelector('[data-expandable-toggle]')?.setAttribute('aria-expanded', 'false');
            panel.querySelector('[data-expandable-description]')?.setAttribute('aria-hidden', 'true');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["droneer-feature-stories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__droneerFeatureStoriesController) {
      window.__droneerFeatureStoriesController.initializeTree(document);
      return;
    }

    const selector = '[data-droneer-feature-stories]';
    const instances = new WeakMap();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeClose = null;

    const getRoots = (scope) => {
      const roots = [];
      if (scope instanceof Element && scope.matches(selector)) roots.push(scope);
      if (scope && typeof scope.querySelectorAll === 'function') roots.push(...scope.querySelectorAll(selector));
      return roots;
    };

    const initialize = (root) => {
      if (instances.has(root)) return;

      const controller = new AbortController();
      const signal = controller.signal;
      const replayButtons = [...root.querySelectorAll('[data-feature-replay]')];
      const openButtons = [...root.querySelectorAll('[data-feature-open]')];
      const closeButtons = [...root.querySelectorAll('[data-feature-close]')];
      const templates = new Map([...root.querySelectorAll('[data-feature-template]')].map((template) => [template.dataset.featureTemplate, template]));
      const modal = root.querySelector('[data-feature-modal]');
      const modalContent = root.querySelector('[data-feature-modal-content]');
      let replayTimer = 0;
      let closeTimer = 0;
      let previousOverflow = '';
      let lastTrigger = null;

      const replay = (button) => {
        const media = button.closest('.droneer-feature-stories__media');
        const video = media ? media.querySelector('.droneer-feature-stories__video') : null;
        if (!video) return;
        window.clearTimeout(replayTimer);
        video.currentTime = 0;
        button.classList.remove('is-ended', 'is-replaying');
        window.requestAnimationFrame(() => button.classList.add('is-replaying'));
        replayTimer = window.setTimeout(() => button.classList.remove('is-replaying'), 520);
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
      };

      const clearModal = () => {
        if (modalContent) modalContent.replaceChildren();
      };

      const closeModal = (restoreFocus = true) => {
        if (!modal || modal.hidden) return;
        window.clearTimeout(closeTimer);
        modal.classList.remove('is-open');
        document.documentElement.style.overflow = previousOverflow;
        closeTimer = window.setTimeout(() => {
          clearModal();
          modal.hidden = true;
          if (restoreFocus && lastTrigger) lastTrigger.focus({ preventScroll: true });
        }, reducedMotion.matches ? 0 : 220);
        if (activeClose === closeModal) activeClose = null;
      };

      const openModal = (button) => {
        if (!modal || !modalContent) return;
        const template = templates.get(button.dataset.featureOpen);
        if (!template) return;
        if (activeClose && activeClose !== closeModal) activeClose(false);

        window.clearTimeout(closeTimer);
        clearModal();
        modalContent.appendChild(template.content.cloneNode(true));
        lastTrigger = button;
        previousOverflow = document.documentElement.style.overflow;
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        activeClose = closeModal;

        window.requestAnimationFrame(() => {
          modal.classList.add('is-open');
          const closeButton = modal.querySelector('.droneer-feature-stories__close');
          if (closeButton) closeButton.focus({ preventScroll: true });
        });
      };

      replayButtons.forEach((button) => {
        const media = button.closest('.droneer-feature-stories__media');
        const video = media ? media.querySelector('.droneer-feature-stories__video') : null;
        button.addEventListener('click', () => replay(button), { signal });
        if (video) {
          video.addEventListener('ended', () => button.classList.add('is-ended'), { signal });
          video.addEventListener('play', () => button.classList.remove('is-ended'), { signal });
        }
      });

      openButtons.forEach((button) => {
        button.addEventListener('click', () => openModal(button), { signal });
      });

      closeButtons.forEach((button) => {
        button.addEventListener('click', () => closeModal(), { signal });
      });

      if (modal) {
        modal.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeModal();
            return;
          }

          if (event.key !== 'Tab') return;
          const focusable = [...modal.querySelectorAll('button:not([disabled]), a[href], input, select, textarea')];
          if (focusable.length === 0) return;
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }, { signal });
      }

      root.addEventListener('shopify:block:select', (event) => {
        const row = event.target.closest('[data-feature-row]');
        if (row) row.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'center' });
      }, { signal });

      instances.set(root, {
        controller,
        cleanup: () => {
          window.clearTimeout(replayTimer);
          window.clearTimeout(closeTimer);
          closeModal(false);
          clearModal();
        }
      });
    };

    const destroy = (root) => {
      const instance = instances.get(root);
      if (!instance) return;
      instance.cleanup();
      instance.controller.abort();
      instances.delete(root);
    };

    const initializeTree = (scope) => getRoots(scope).forEach(initialize);
    const destroyTree = (scope) => getRoots(scope).forEach(destroy);

    window.__droneerFeatureStoriesController = { initializeTree, destroyTree };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeTree(document), { once: true });
    } else {
      initializeTree(document);
    }

    document.addEventListener('shopify:section:load', (event) => initializeTree(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroyTree(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["droneer-media-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__droneerMediaShowcaseController) {
      window.__droneerMediaShowcaseController.initializeTree(document);
      return;
    }

    const selector = '[data-droneer-media-showcase]';
    const instances = new WeakMap();

    const getRoots = (scope) => {
      const roots = [];
      if (scope instanceof Element && scope.matches(selector)) roots.push(scope);
      if (scope && typeof scope.querySelectorAll === 'function') roots.push(...scope.querySelectorAll(selector));
      return roots;
    };

    const initialize = (root) => {
      if (instances.has(root)) return;

      const video = root.querySelector('.droneer-media-showcase__video');
      const replayButton = root.querySelector('[data-droneer-replay]');
      if (!video || !replayButton) return;

      const controller = new AbortController();
      const signal = controller.signal;
      let replayTimer;

      const replay = () => {
        window.clearTimeout(replayTimer);
        video.currentTime = 0;
        root.classList.remove('is-video-ended');
        replayButton.classList.remove('is-replaying');
        window.requestAnimationFrame(() => replayButton.classList.add('is-replaying'));
        replayTimer = window.setTimeout(() => replayButton.classList.remove('is-replaying'), 520);
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
      };

      replayButton.addEventListener('click', replay, { signal });
      video.addEventListener('ended', () => {
        root.classList.add('is-video-ended');
        video.currentTime = 0;
        video.pause();
      }, { signal });
      video.addEventListener('play', () => root.classList.remove('is-video-ended'), { signal });

      instances.set(root, { controller, replayTimer: () => replayTimer });
    };

    const destroy = (root) => {
      const instance = instances.get(root);
      if (!instance) return;
      window.clearTimeout(instance.replayTimer());
      instance.controller.abort();
      instances.delete(root);
    };

    const initializeTree = (scope) => getRoots(scope).forEach(initialize);
    const destroyTree = (scope) => getRoots(scope).forEach(destroy);

    window.__droneerMediaShowcaseController = { initializeTree, destroyTree };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeTree(document), { once: true });
    } else {
      initializeTree(document);
    }

    document.addEventListener('shopify:section:load', (event) => initializeTree(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroyTree(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["droneer-product-subnav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('droneer-product-subnav')) return;

    class DroneerProductSubnav extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;

        this.abortController = new AbortController();
        this.signal = this.abortController.signal;
        this.bar = this.querySelector('[data-subnav-bar]');
        this.linksTrack = this.querySelector('[data-subnav-links]');
        this.previousButton = this.querySelector('[data-subnav-previous]');
        this.nextButton = this.querySelector('[data-subnav-next]');
        this.links = Array.from(this.querySelectorAll('[data-target-id]'));
        this.sectionId = this.dataset.sectionId;
        this.pageHeader = document.querySelector('[data-x501-product-header]')?.closest('.shopify-section');
        this.triggerOffset = Number.parseFloat(this.dataset.triggerOffset) || 0;
        this.smoothScroll = this.dataset.smoothScroll === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.designMode = this.dataset.designMode === 'true';
        this.frame = null;
        this.targets = [];

        this.refreshTargets();

        this.links.forEach((link) => {
          link.addEventListener('click', (event) => this.handleLinkClick(event, link), { signal: this.signal });
        });

        this.previousButton?.addEventListener('click', () => this.scrollMobileLinks(-1), { signal: this.signal });
        this.nextButton?.addEventListener('click', () => this.scrollMobileLinks(1), { signal: this.signal });
        this.linksTrack.addEventListener('scroll', () => this.updateArrowButtons(), { passive: true, signal: this.signal });
        window.addEventListener('scroll', () => this.scheduleUpdate(), { passive: true, signal: this.signal });
        window.addEventListener('resize', () => {
          this.refreshTargets();
          this.scheduleUpdate();
        }, { passive: true, signal: this.signal });

        document.addEventListener('shopify:block:select', (event) => this.handleBlockSelect(event), { signal: this.signal });
        document.addEventListener('shopify:section:select', (event) => this.handleSectionSelect(event), { signal: this.signal });

        this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
        this.resizeObserver.observe(this.linksTrack);
        this.scheduleUpdate();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.pageHeader?.classList.remove('is-product-nav-handoff');
        if (this.frame) cancelAnimationFrame(this.frame);
        this.abortController = null;
      }

      safeEscape(value) {
        if (window.CSS?.escape) return window.CSS.escape(value);
        return value.replace(/([ #;&,.+*~':"!^$[\]()=>|/@])/g, '\\$1');
      }

      resolveTarget(rawValue) {
        const value = (rawValue || '').trim();
        if (!value) return null;

        if (['#', '.', '['].includes(value[0])) {
          try {
            const selected = document.querySelector(value);
            if (selected) return selected;
          } catch (_error) {}
        }

        const exact = document.getElementById(value);
        if (exact) return exact;

        try {
          const shopifySection = document.querySelector(`[id$="__${this.safeEscape(value)}"]`);
          if (shopifySection) return shopifySection;
        } catch (_error) {}

        try {
          return document.querySelector(value);
        } catch (_error) {
          return null;
        }
      }

      refreshTargets() {
        this.trigger = this.resolveTarget(this.dataset.triggerId) || this.closest('.shopify-section')?.nextElementSibling;
        this.targets = this.links
          .map((link) => ({ link, target: this.resolveTarget(link.dataset.targetId) }))
          .filter((item) => item.target);
      }

      scheduleUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      update() {
        const pageHeaderHeight = this.pageHeader?.getBoundingClientRect().height || 0;
        const revealOffset = Math.max(this.triggerOffset, pageHeaderHeight);
        const shouldShow = this.designMode || (this.trigger && this.trigger.getBoundingClientRect().top <= revealOffset);
        this.bar.classList.toggle('is-visible', Boolean(shouldShow));
        this.bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        this.bar.inert = !shouldShow;
        this.pageHeader?.classList.toggle('is-product-nav-handoff', Boolean(shouldShow));

        if (shouldShow) this.updateActiveLink();
        this.updateArrowButtons();
      }

      updateActiveLink() {
        if (!this.targets.length) return;

        const threshold = this.bar.getBoundingClientRect().height + 28;
        let active = this.targets[0];
        let closestTop = Number.NEGATIVE_INFINITY;

        this.targets.forEach((item) => {
          const targetTop = item.target.getBoundingClientRect().top;
          if (targetTop <= threshold && targetTop > closestTop) {
            active = item;
            closestTop = targetTop;
          }
        });

        this.links.forEach((link) => {
          const isActive = link === active.link;
          link.classList.toggle('is-active', isActive);
          if (isActive) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });

        if (window.innerWidth < 750 && active.link) {
          active.link.scrollIntoView({ behavior: this.smoothScroll ? 'smooth' : 'auto', block: 'nearest', inline: 'center' });
        }
      }

      handleLinkClick(event, link) {
        const target = this.resolveTarget(link.dataset.targetId);
        if (!target) return;

        event.preventDefault();
        const barHeight = this.bar.getBoundingClientRect().height;
        const targetTop = target.getBoundingClientRect().top + window.scrollY - barHeight;
        window.scrollTo({ top: Math.max(0, targetTop), behavior: this.smoothScroll ? 'smooth' : 'auto' });

        if (target.id) history.replaceState(null, '', `#${target.id}`);
      }

      updateArrowButtons() {
        if (!this.linksTrack) return;
        const hasOverflow = this.linksTrack.scrollWidth > this.linksTrack.clientWidth + 2;
        const maxScroll = Math.max(0, this.linksTrack.scrollWidth - this.linksTrack.clientWidth);
        const atStart = this.linksTrack.scrollLeft <= 2;
        const atEnd = this.linksTrack.scrollLeft >= maxScroll - 2;

        if (this.previousButton) this.previousButton.hidden = !hasOverflow || atStart;
        if (this.nextButton) this.nextButton.hidden = !hasOverflow || atEnd;
      }

      scrollMobileLinks(direction) {
        this.linksTrack.scrollBy({
          left: direction * this.linksTrack.clientWidth * 0.72,
          behavior: this.smoothScroll ? 'smooth' : 'auto'
        });
        window.setTimeout(() => this.updateArrowButtons(), 260);
      }

      handleBlockSelect(event) {
        const selected = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
        if (!selected) return;
        this.bar.classList.add('is-visible');
        this.bar.setAttribute('aria-hidden', 'false');
        this.bar.inert = false;
        this.pageHeader?.classList.add('is-product-nav-handoff');
        selected.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      handleSectionSelect(event) {
        if (event.detail.sectionId !== this.sectionId) return;
        this.bar.classList.add('is-visible');
        this.bar.setAttribute('aria-hidden', 'false');
        this.bar.inert = false;
        this.pageHeader?.classList.add('is-product-nav-handoff');
      }
    }

    customElements.define('droneer-product-subnav', DroneerProductSubnav);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["droneer-x501-3d-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__droneerX501SectionController) {
      window.__droneerX501SectionController.initializeTree(document);
      return;
    }

    const selector = '[data-droneer-x501-3d]';
    const instances = new WeakMap();

    const ensureModelViewer = () => {
      if (customElements.get('model-viewer')) return Promise.resolve();
      if (window.__droneerX501ModelViewerPromise) return window.__droneerX501ModelViewerPromise;

      window.__droneerX501ModelViewerPromise = new Promise((resolve, reject) => {
        if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
          reject(new Error('Shopify model viewer loader is unavailable.'));
          return;
        }

        const timeout = window.setTimeout(() => reject(new Error('Model viewer loading timed out.')), 20000);

        window.Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: () => {
              customElements.whenDefined('model-viewer').then(() => {
                window.clearTimeout(timeout);
                resolve();
              });
            }
          }
        ]);
      }).catch((error) => {
        window.__droneerX501ModelViewerPromise = undefined;
        throw error;
      });

      return window.__droneerX501ModelViewerPromise;
    };

    const getRoots = (scope) => {
      const roots = [];
      if (scope instanceof Element && scope.matches(selector)) roots.push(scope);
      if (scope && typeof scope.querySelectorAll === 'function') roots.push(...scope.querySelectorAll(selector));
      return roots;
    };

    const markReady = (root) => {
      root.classList.remove('has-model-error');
      root.classList.add('is-model-ready');
    };

    const markError = (root) => {
      root.classList.remove('is-model-ready');
      root.classList.add('has-model-error');
    };

    const initialize = (root) => {
      if (instances.has(root)) return;

      const viewer = root.querySelector('model-viewer');
      if (!viewer) {
        markError(root);
        return;
      }

      const controller = new AbortController();
      const signal = controller.signal;
      let observer;
      let pointerStart;

      const restoreHint = () => {
        pointerStart = undefined;
        root.classList.remove('has-interacted');
      };

      viewer.setAttribute('camera-controls', '');
      viewer.setAttribute('touch-action', 'pan-y');
      viewer.setAttribute('disable-pan', '');
      viewer.setAttribute('interaction-prompt', 'none');
      const initialCameraOrbit = window.matchMedia('(min-width: 1024px)').matches
        ? root.dataset.desktopCameraOrbit
        : root.dataset.cameraOrbit;

      viewer.setAttribute('camera-orbit', initialCameraOrbit || '25deg 72deg 105%');
      viewer.setAttribute('min-camera-orbit', root.dataset.minCameraOrbit || 'auto 35deg 55%');
      viewer.setAttribute('max-camera-orbit', root.dataset.maxCameraOrbit || 'auto 92deg 190%');
      viewer.removeAttribute('disable-zoom');

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (root.dataset.autoRotate === 'true' && !reducedMotion) {
        viewer.setAttribute('auto-rotate', '');
        viewer.setAttribute('rotation-per-second', root.dataset.rotationSpeed || '8deg');
        viewer.setAttribute('auto-rotate-delay', '1200');
      } else {
        viewer.removeAttribute('auto-rotate');
      }

      if (root.dataset.enableAr === 'true') {
        viewer.setAttribute('ar', '');
        viewer.setAttribute('ar-modes', 'webxr scene-viewer quick-look');
        viewer.setAttribute('ar-scale', 'fixed');

        if (!viewer.querySelector('[slot="ar-button"]')) {
          const arButton = document.createElement('button');
          arButton.type = 'button';
          arButton.slot = 'ar-button';
          arButton.className = 'droneer-x501-3d__ar-button';
          arButton.textContent = root.dataset.arButtonLabel || 'View in your space';
          viewer.appendChild(arButton);
        }
      } else {
        viewer.removeAttribute('ar');
      }

      if (root.dataset.modelAlt) viewer.setAttribute('alt', root.dataset.modelAlt);

      viewer.addEventListener('load', () => markReady(root), { signal });
      viewer.addEventListener('error', () => markError(root), { signal });

      viewer.addEventListener('pointerdown', (event) => {
        pointerStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
      }, { signal });

      viewer.addEventListener('pointermove', (event) => {
        if (!pointerStart || pointerStart.id !== event.pointerId) return;
        const horizontalDistance = Math.abs(event.clientX - pointerStart.x);
        const verticalDistance = Math.abs(event.clientY - pointerStart.y);
        if (horizontalDistance > 8 && horizontalDistance > verticalDistance) root.classList.add('has-interacted');
      }, { signal });

      viewer.addEventListener('pointerup', () => {
        pointerStart = undefined;
      }, { signal });

      viewer.addEventListener('pointercancel', () => {
        pointerStart = undefined;
      }, { signal });

      viewer.addEventListener('wheel', () => root.classList.add('has-interacted'), { passive: true, signal });

      viewer.addEventListener('pointerleave', () => {
        if (!pointerStart) restoreHint();
      }, { signal });

      viewer.addEventListener('focusout', (event) => {
        if (event.relatedTarget instanceof Node && root.contains(event.relatedTarget)) return;
        restoreHint();
      }, { signal });

      viewer.addEventListener('blur', restoreHint, { signal });

      document.addEventListener('pointerdown', (event) => {
        if (!root.contains(event.target)) restoreHint();
      }, { signal });

      const loadViewer = () => {
        ensureModelViewer()
          .then(() => {
            if (viewer.loaded) markReady(root);
          })
          .catch(() => markError(root));
      };

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          loadViewer();
        }, { rootMargin: '300px 0px' });
        observer.observe(root);
      } else {
        loadViewer();
      }

      instances.set(root, { controller, observer });
    };

    const destroy = (root) => {
      const instance = instances.get(root);
      if (!instance) return;
      instance.observer?.disconnect();
      instance.controller.abort();
      instances.delete(root);
    };

    const initializeTree = (scope) => getRoots(scope).forEach(initialize);
    const destroyTree = (scope) => getRoots(scope).forEach(destroy);

    window.__droneerX501SectionController = { initializeTree, destroyTree };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeTree(document), { once: true });
    } else {
      initializeTree(document);
    }

    document.addEventListener('shopify:section:load', (event) => initializeTree(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroyTree(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["droneer-youtube-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__droneerYoutubeReviewsController) {
      window.__droneerYoutubeReviewsController.initializeTree(document);
      return;
    }

    const selector = '[data-droneer-youtube-reviews]';
    const instances = new WeakMap();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeClose = null;

    const getRoots = (scope) => {
      const roots = [];
      if (scope instanceof Element && scope.matches(selector)) roots.push(scope);
      if (scope && typeof scope.querySelectorAll === 'function') roots.push(...scope.querySelectorAll(selector));
      return roots;
    };

    const initialize = (root) => {
      if (instances.has(root)) return;

      const track = root.querySelector('[data-reviews-track]');
      const cards = [...root.querySelectorAll('[data-review-card]')];
      const dots = [...root.querySelectorAll('[data-review-dot]')];
      const previous = root.querySelector('[data-review-previous]');
      const next = root.querySelector('[data-review-next]');
      const modal = root.querySelector('[data-review-modal]');
      const player = root.querySelector('[data-review-player]');
      const openButtons = [...root.querySelectorAll('[data-review-open]')];
      const closeButtons = [...root.querySelectorAll('[data-review-close]')];
      const youtubeThumbnails = [...root.querySelectorAll('[data-youtube-thumbnail]')];
      const controller = new AbortController();
      const signal = controller.signal;
      let frameRequest = 0;
      let closeTimer = 0;
      let lastTrigger = null;
      let previousOverflow = '';

      const cardPosition = (card) => card.offsetLeft - cards[0].offsetLeft;

      const loadYoutubeThumbnail = (container) => {
        const videoId = container.dataset.videoId;
        if (!videoId) return;

        const image = new Image(480, 360);
        image.className = 'droneer-youtube-reviews__media-image';
        image.alt = container.dataset.thumbnailAlt || '';
        image.loading = container.dataset.thumbnailLoading === 'eager' ? 'eager' : 'lazy';
        image.decoding = 'async';
        container.replaceChildren(image);
        image.src = `https://i.ytimg.com/vi/${encodeURIComponent(videoId)}/hqdefault.jpg`;
      };

      const updateControls = () => {
        if (!track || cards.length === 0) return;
        const position = track.scrollLeft;
        let activeIndex = 0;
        let smallestDistance = Number.POSITIVE_INFINITY;

        cards.forEach((card, index) => {
          const distance = Math.abs(cardPosition(card) - position);
          if (distance < smallestDistance) {
            smallestDistance = distance;
            activeIndex = index;
          }
        });

        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        if (previous) previous.disabled = position <= 2;
        if (next) next.disabled = position >= maximum;
      };

      const scheduleUpdate = () => {
        window.cancelAnimationFrame(frameRequest);
        frameRequest = window.requestAnimationFrame(updateControls);
      };

      const scrollToCard = (index) => {
        if (!track || !cards[index]) return;
        track.scrollTo({
          left: cardPosition(cards[index]),
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });
      };

      const currentIndex = () => {
        if (!track || cards.length === 0) return 0;
        const position = track.scrollLeft;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;
        cards.forEach((card, index) => {
          const distance = Math.abs(cardPosition(card) - position);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        return closestIndex;
      };

      const clearPlayer = () => {
        if (player) player.replaceChildren();
      };

      const closeModal = (restoreFocus = true) => {
        if (!modal || modal.hidden) return;
        window.clearTimeout(closeTimer);
        modal.classList.remove('is-open');
        document.documentElement.style.overflow = previousOverflow;
        closeTimer = window.setTimeout(() => {
          clearPlayer();
          modal.hidden = true;
          if (restoreFocus && lastTrigger) lastTrigger.focus({ preventScroll: true });
        }, reducedMotion.matches ? 0 : 200);
        if (activeClose === closeModal) activeClose = null;
      };

      const openModal = (button) => {
        const videoId = button.dataset.videoId;
        if (!modal || !player || !videoId) return;
        if (activeClose && activeClose !== closeModal) activeClose(false);

        window.clearTimeout(closeTimer);
        lastTrigger = button;
        previousOverflow = document.documentElement.style.overflow;
        clearPlayer();

        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
        iframe.title = button.dataset.videoTitle || '';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        player.appendChild(iframe);

        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        activeClose = closeModal;
        window.requestAnimationFrame(() => {
          modal.classList.add('is-open');
          const closeButton = modal.querySelector('.droneer-youtube-reviews__close');
          if (closeButton) closeButton.focus({ preventScroll: true });
        });
      };

      if (track) track.addEventListener('scroll', scheduleUpdate, { passive: true, signal });
      window.addEventListener('resize', scheduleUpdate, { passive: true, signal });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => scrollToCard(Number(dot.dataset.reviewDot)), { signal });
      });

      if (previous) {
        previous.addEventListener('click', () => scrollToCard(Math.max(0, currentIndex() - 1)), { signal });
      }

      if (next) {
        next.addEventListener('click', () => scrollToCard(Math.min(cards.length - 1, currentIndex() + 1)), { signal });
      }

      openButtons.forEach((button) => {
        button.addEventListener('click', () => openModal(button), { signal });
      });

      closeButtons.forEach((button) => {
        button.addEventListener('click', () => closeModal(), { signal });
      });

      youtubeThumbnails.forEach(loadYoutubeThumbnail);

      if (modal) {
        modal.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeModal();
            return;
          }

          if (event.key !== 'Tab') return;
          const focusable = [...modal.querySelectorAll('button:not([disabled]), iframe')];
          if (focusable.length === 0) return;
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }, { signal });
      }

      root.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('[data-review-card]');
        const index = cards.indexOf(card);
        if (index >= 0) scrollToCard(index);
      }, { signal });

      updateControls();
      instances.set(root, {
        controller,
        closeModal,
        cleanup: () => {
          window.cancelAnimationFrame(frameRequest);
          window.clearTimeout(closeTimer);
          closeModal(false);
          clearPlayer();
        }
      });
    };

    const destroy = (root) => {
      const instance = instances.get(root);
      if (!instance) return;
      instance.cleanup();
      instance.controller.abort();
      instances.delete(root);
    };

    const initializeTree = (scope) => getRoots(scope).forEach(initialize);
    const destroyTree = (scope) => getRoots(scope).forEach(destroy);

    window.__droneerYoutubeReviewsController = { initializeTree, destroyTree };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeTree(document), { once: true });
    } else {
      initializeTree(document);
    }

    document.addEventListener('shopify:section:load', (event) => initializeTree(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroyTree(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
